import React, { useEffect, useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBreakdownTabContext } from '../../contexts/BreakdownTabContext';
import { useBreakdownDataLoader } from '../../hooks/useBreakdownDataLoader';
import BreakdownMain from '../Breakdown/BreakdownMain/BreakdownMain';

/** `#/breakdown/:breakdownId`：分场分景主表。 */
const BreakdownContainer: React.FC = () => {
  const navigate = useNavigate();
  const { breakdownId: breakdownIdParam } = useParams<{ breakdownId: string }>();
  const { t } = useTranslation();
  const { breakdownId, setBreakdownId, switchTab } = useBreakdownTabContext();

  useLayoutEffect(() => {
    if (breakdownIdParam) {
      setBreakdownId(breakdownIdParam);
      switchTab('breakdown');
    }
  }, [breakdownIdParam, setBreakdownId, switchTab]);

  const effectiveBreakdownId = breakdownIdParam || breakdownId;

  const { loading: breakdownBootstrapLoading, error: breakdownBootstrapError } = useBreakdownDataLoader({
    breakdownId: effectiveBreakdownId || '',
    forceRefresh: false,
  });

  useEffect(() => {
    if (!effectiveBreakdownId) {
      navigate('/', { replace: true });
    }
  }, [effectiveBreakdownId, navigate]);

  if (!effectiveBreakdownId) {
    return null;
  }

  if (breakdownBootstrapLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 60,
          color: 'var(--color-gray2, #888)',
        }}
      >
        <span>{t('common.loading')}</span>
      </div>
    );
  }

  if (breakdownBootstrapError) {
    return (
      <div style={{ padding: 24, color: 'var(--error-color, #c00)' }}>
        {breakdownBootstrapError}
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <BreakdownMain breakdownId={effectiveBreakdownId} />
    </div>
  );
};

export default BreakdownContainer;
